import { CostType } from './cost-type';

export class LegCost {
  id?: number = null;
  flightRequestId: number = null;
  legId: string = null;
  costType: CostType = null;
  amount: number = null;
}
